import React, { useEffect, useState } from 'react'
import { FormCustom, Input, SwitchToggle } from '../../../components/form'
import ReactPlaceholder from 'react-placeholder/lib'
import { useGetId, useSaveUpdate } from '../../../hooks/process-data'
import { useMemo } from 'react'
import { doRequestGet } from '../../../api'
import SelectCustom from '../../../components/select-custom/SelectCustom'
import { Button } from 'react-bootstrap'
import { apiResource, doToast } from '../../../utils'
import { toast } from 'react-toastify'
import ColorPicker from "react-pick-color";

const EventZoneForm = ({ rowId, eventId, setReload }) => {
  const [row, setRow] = useState({
    p_id_event_zone: '',
    p_id_event: eventId,
    p_capacity_event_zone: '',
    p_price_event_zone: '',
    p_id_type_event_zone: '',
    p_name_event_zone: '',
    p_enabled_event_zone: 0,
    p_qty_event_zone: '',
    p_details_event_zone: [],
    p_image_event_zone: [],
    p_image_event_zone_path: '',
    p_color_event_zone: '#000000',
    p_price_ticket_event_zone: '',
    p_charge_service_event_zone: '',
    p_pdf_type_event_zone: '',
    p_days: [
      { value: 1, label: 'D', checked: 0 },
      { value: 2, label: 'L', checked: 0 },
      { value: 3, label: 'M', checked: 0 },
      { value: 4, label: 'M', checked: 0 },
      { value: 5, label: 'J', checked: 0 },
      { value: 6, label: 'V', checked: 0 },
      { value: 7, label: 'S', checked: 0 },
    ],
    p_has_payment: false,
    p_coordinates: '',
  })
  const [ready, setReady] = useState(false);
  const [typeEventsZone, setTypeEventsZone] = useState([])
  const [previewImage, setPreviewImage] = useState(null);

  const dataSubmit = useMemo(() => {
    let formData = new FormData();

    for (const key in row) {
      if (key === 'p_image_event_zone') {
        if (row[key].length > 0) {
          formData.append(key, row[key][0]);
        }
      } else if (key === 'p_details_event_zone') {
        if (row[key].length > 0) {
          formData.append(key, JSON.stringify(row[key]));
        }
      } else if (key === 'p_days') {
        if (row[key].length > 0) {
          formData.append(key, JSON.stringify(row[key]));
        }
      } else {
        formData.append(key, row[key]);
      }
    }

    return formData;
  }, [row])

  const { doSubmit, setDoSubmit } = useSaveUpdate({
    data: dataSubmit,
    url: row.p_has_payment ? '/event-zone/update' : '/event-zone',
    hasFile: true,
    setReload
  })

  const { isProcessing, getRow, error } = useGetId({
    url: '/event-zone/' + rowId,
    rowId: rowId
  })

  const [pdfTypes] = useState([
    { id_pdf_type_event_zone: 'POR_DEFECTO', name_pdf_type_event_zone: 'POR DEFECTO' },
    { id_pdf_type_event_zone: 'BOLETO', name_pdf_type_event_zone: 'BOLETO' },
  ])

  useEffect(() => {
    const getData = async function () {
      if (error) {
        setReload();
      } else {
        if (!isProcessing && !ready) {
          const getTypesEventsZone = await doRequestGet({
            url: '/type-event-zone'
          })
          setTypeEventsZone(getTypesEventsZone.data);

          if (rowId) {
            setRow({
              p_id_event_zone: getRow.id_event_zone,
              p_name_event_zone: getRow.name_event_zone,
              p_id_event: getRow.id_event,
              p_capacity_event_zone: getRow.capacity_event_zone,
              p_price_event_zone: getRow.price_event_zone,
              p_id_type_event_zone: getRow.id_type_event_zone,
              p_enabled_event_zone: getRow.enabled_event_zone,
              p_qty_event_zone: getRow.qty_event_zone ? getRow.qty_event_zone : '',
              p_details_event_zone: getRow.details_event_zone,
              p_image_event_zone: [],
              p_image_event_zone_path: getRow.image_event_zone,
              p_color_event_zone: getRow.color_event_zone,
              p_price_ticket_event_zone: getRow.price_ticket_event_zone ? getRow.price_ticket_event_zone : '',
              p_charge_service_event_zone: getRow.charge_service_event_zone ? getRow.charge_service_event_zone : '',
              p_pdf_type_event_zone: getRow.pdf_type_event_zone ? getRow.pdf_type_event_zone : '',
              p_days: getRow.days ? getRow.days : [],
              p_has_payment: getRow.has_payment,
              p_coordinates: getRow.coordinates ? getRow.coordinates : '',
            })
          }
          setReady(true);
        }
      }
    }

    getData();
  }, [isProcessing, getRow, error, setReload, rowId, ready])

  return <ReactPlaceholder ready={ready} rows={5}>
    <FormCustom onSubmit={() => {
      if (!row.p_id_type_event_zone) {
        doToast({
          response: 'warning',
          message: 'Debe seleccionar un tipo de zona de evento.',
          toast
        })
        return
      }

      if ((parseInt(row.p_id_type_event_zone) === 2 || parseInt(row.p_id_type_event_zone) === 3) && row.p_details_event_zone.length === 0) {
        doToast({
          response: 'warning',
          message: 'Debe agregar al menos un detalle de zona de evento.',
          toast
        })
        return
      }

      setDoSubmit(true)
    }} loadSubmit={doSubmit}>
      {row.p_has_payment && <div className="alert alert-warning w-100">
        Ya existen tickets comprados en la zona, solo es posible editar algunos campos.
      </div>}
      <Input
        text="Nombre"
        placeholder="Nombre"
        classNameParent="col-12 mb-3"
        required
        invalid="El campo es obligatorio."
        value={row.p_name_event_zone}
        onChange={e => setRow({
          ...row,
          p_name_event_zone: e.target.value
        })}
        maxLength={255}
      />
      <Input
        text="Color"
        placeholder="Color"
        classNameParent="col-12 mb-3"
        required
        invalid="El campo es obligatorio."
        value={row.p_color_event_zone}
        onChange={e => setRow({ ...row, p_color_event_zone: e.target.value })}
        maxLength={100}
        readOnly
      />
      <ColorPicker className='mb-4' color={row.p_color_event_zone} onChange={(color) => setRow({ ...row, p_color_event_zone: color.hex })} />
      <SelectCustom
        valueId={row.p_id_type_event_zone}
        keyName="type_event_zone"
        options={typeEventsZone}
        setRow={setRow}
        row={row}
        selectText="Tipo de Zona"
        selectPops={{
          classNameParent: 'col-12 mb-3'
        }}
        disabled={row.p_has_payment}
      />
      {parseInt(row.p_id_type_event_zone) === 1 && <Input
        text="Capacidad"
        placeholder="Capacidad"
        type="number"
        step="1"
        min="1"
        classNameParent="col-12 mb-3"
        required
        invalid="El campo es obligatorio."
        value={row.p_capacity_event_zone}
        onChange={e => setRow({ ...row, p_capacity_event_zone: e.target.value })}
        disabled={row.p_has_payment}
      />}
      {parseInt(row.p_id_type_event_zone) === 3 && <Input
        text="Cantidad de Personas por Box"
        placeholder="Cantidad de Personas por Box"
        type="number"
        step="1"
        min="1"
        classNameParent="col-12 mb-3"
        required
        invalid="El campo es obligatorio."
        value={row.p_qty_event_zone}
        onChange={e => setRow({ ...row, p_qty_event_zone: e.target.value })}
        disabled={row.p_has_payment}
      />}
      <Input
        text="Precio"
        placeholder="Precio"
        type="number"
        step="0.01"
        min="0.01"
        classNameParent="col-12 mb-3"
        required
        invalid="El campo es obligatorio."
        value={row.p_price_event_zone}
        onChange={e => setRow({ ...row, p_price_event_zone: e.target.value })}
        disabled={row.p_has_payment}
      />
      <Input
        text="Precio Boleto"
        placeholder="Precio Boleto"
        type="number"
        step="0.01"
        min="0.01"
        classNameParent="col-12 mb-3"
        invalid="El campo es obligatorio."
        value={row.p_price_ticket_event_zone}
        onChange={e => setRow({ ...row, p_price_ticket_event_zone: e.target.value })}
        disabled={row.p_has_payment}
      />
      <Input
        text="Cargo por Servicio"
        placeholder="Cargo por Servicio"
        type="number"
        step="0.01"
        min="0.01"
        classNameParent="col-12 mb-3"
        invalid="El campo es obligatorio."
        value={row.p_charge_service_event_zone}
        onChange={e => setRow({ ...row, p_charge_service_event_zone: e.target.value })}
        disabled={row.p_has_payment}
      />
      <SelectCustom
        valueId={row.p_pdf_type_event_zone}
        onChangeKey="p_pdf_type_event_zone"
        keyName="pdf_type_event_zone"
        options={pdfTypes}
        setRow={setRow}
        row={row}
        selectText="Tipo PDF"
        keyIsString
        showEnabled={false}
        selectPops={{
          classNameParent: 'col-12 mb-3'
        }}
        disabled={row.p_has_payment}
      />
      <Input
        type="file"
        text="Imagen Referencial de la Zona"
        classNameParent="col-12 mb-3"
        required={rowId === ''}
        invalid="El campo es obligatorio."
        onChange={e => {
          const files = e.target.files
          setRow({ ...row, p_image_event_zone: files })
          setPreviewImage(files.length > 0 ? URL.createObjectURL(files[0]) : null)
        }}
        accept="image/*"
      />
      {(row.p_image_event_zone_path || previewImage) && <div className='col-12 mb-3'>
        <small className='text-muted'>
          Vista Previa
        </small>
        <div>
          <img src={previewImage ? previewImage : (apiResource({
            url: row.p_image_event_zone_path
          }))} alt={row.p_name_event_zone} className="max-width-200 rounded" />
        </div>
      </div>}
      <SwitchToggle
        id="event_zone-enabled"
        textCheck="Desactivar"
        textUnChecked="Activar"
        classNameParent="col-12 mb-3"
        checked={row.p_enabled_event_zone === 1}
        onChange={e => setRow({ ...row, p_enabled_event_zone: e.target.checked ? 1 : 0 })}
      />

      <Input
        text="Coordenadas"
        placeholder="Coordenadas"
        classNameParent="col-12 mb-3"
        invalid="El campo es obligatorio."
        value={row.p_coordinates}
        onChange={e => setRow({ ...row, p_coordinates: e.target.value })}
      />

      <div className='d-flex w-100 mb-2'>
        <div className='align-self-center me-2'><strong>Promoción 2x1</strong></div>
      </div>
      <div className="d-flex">
        {row.p_days.map((d, dIdx) => {
          return <Input
            type="checkbox"
            text={d.label}
            classNameParent="me-3"
            onChange={e => {
              setRow({
                ...row,
                p_days: row.p_days.map((d2, dIdx2) => {
                  if (dIdx === dIdx2) {
                    d.checked = e.target.checked ? 1 : 0
                  }

                  return d2
                })
              })
            }}
            checked={d.checked}
          />
        })}
      </div>
      <div className="mb-3 w-100"></div>

      {(parseInt(row.p_id_type_event_zone) === 2 || parseInt(row.p_id_type_event_zone) === 3) && <div className='col-12 mb-2 mt-3'>
        <div className='d-flex'>
          <div className='align-self-center me-2'><strong>Detalle de Ubicaciones</strong></div>
        </div>

        <div className='table-responsive mt-2'>
          <table className='dt-react table table-sm table-hover table-striped table-bordered'>
            <thead>
              <tr>
                <th>Fila</th>
                <th>Cantidad de Ubicaciones</th>
              </tr>
            </thead>
            <tbody>
              {React.Children.toArray(row.p_details_event_zone.map((item, index) => {
                return <tr>
                  <td className='text-center'>
                    <div className="d-flex justify-content-center">
                      <div className='align-self-center me-2'>{index + 1}</div>
                      <div className='align-self-center'>
                        {!row.p_has_payment && <Button variant='danger' size="xs" onClick={_ => {
                          if (row.p_has_payment) {
                            return;
                          }
                          const newDetails = [...row.p_details_event_zone];
                          newDetails.splice(index, 1);
                          setRow({
                            ...row,
                            p_details_event_zone: newDetails
                          })
                        }}>
                          <i className='fa fa-times'></i>
                        </Button>}
                      </div>
                    </div>
                  </td>
                  <td className='d-flex justify-content-center'>
                    <Input
                      classNameParent=""
                      type="number"
                      step="1"
                      min="1"
                      required
                      className="text-center"
                      invalid="El campo es obligatorio."
                      value={item}
                      onChange={e => {
                        const newDetails = [...row.p_details_event_zone];
                        newDetails[index] = e.target.value;
                        setRow({
                          ...row,
                          p_details_event_zone: newDetails
                        })
                      }}
                      style={{
                        maxWidth: 100
                      }}
                      disabled={row.p_has_payment}
                    />
                  </td>
                </tr>
              }))}
              {!row.p_has_payment && <tr>
                <td colSpan="2" className='text-center p-3'>
                  <Button variant='info' onClick={_ => {
                    if (row.p_has_payment) {
                      return;
                    }
                    setRow({
                      ...row,
                      p_details_event_zone: [...row.p_details_event_zone, '']
                    })
                  }}>
                    <i className='fa fa-plus'></i>
                  </Button>
                </td>
              </tr>}
            </tbody>
          </table>
        </div>

      </div>}
    </FormCustom>
  </ReactPlaceholder>
}

EventZoneForm.defaultProps = {
  rowId: '',
  setReload: () => { },
}

export {
  EventZoneForm
};